/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { ENTITY_TYPES } from '../../../constants/Repository.constants';
import { RECOMMENDED_RUNTIME_IMAGE } from '../../../constants/RuntimeImage.constants';
import { JobDto, JobRecord } from '../Job';

export const createMockJobDto = (partialRecord: Partial<JobRecord> = {}): JobDto => {
  const tenant = faker.string.uuid();
  const version = Array.from({ length: 3 })
    .map(() => faker.number.int())
    .join('.');

  return {
    pk: {
      S: partialRecord.pk ?? `${ENTITY_TYPES.job}~${tenant}`,
    },
    sk: {
      S: partialRecord.sk ?? `${faker.lorem.word()}-${faker.lorem.word()}`,
    },
    name: {
      S: partialRecord.name ?? faker.lorem.word(),
    },
    description: {
      S: partialRecord.description ?? faker.lorem.word(),
    },
    version: {
      S: partialRecord.version ?? version,
    },
    image: {
      S: partialRecord.image ?? RECOMMENDED_RUNTIME_IMAGE,
    },
  };
};

export const createMockJobDtos = (size?: number): Array<JobDto> => {
  const randomSize = size ?? faker.number.int({ max: 3, min: 1 });
  return Array.from({ length: randomSize }).map(() => createMockJobDto());
};
